export default {
  "head.index": "ホーム"
};
